import { ButtonBase, makeStyles } from "@material-ui/core";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/button/Button";
import Flex from "../../components/flex/Flex";
import Text from "../../components/text/Text";
import BasicLayout from "../../layouts/basic/BasicLayout";
import MainLayout from "../../layouts/main/MainLayout";
import { actionError, actionShow } from "../../redux/action/ActionActions";
import colors from "../../libs/colors";
import fonts from "../../libs/fonts";
import Form from "./Form";
import Header from "./Header";
import History from "./History";
import List from "./List";
import Tabs from "./Tabs";
import { Redirect, useHistory, useLocation } from "react-router";
import routes, { ROLE } from "../../libs/routes";
import * as APIS from "../../libs/apis";

export default function Trading({}) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const auth = useSelector((state) => state.auth);

  const initType = location?.state?.type;
  const [index, setIndex] = useState(initType === "silver" ? 1 : 0);
  const [price, setPrice] = useState("");
  const [method, setmethod] = useState(location?.state?.method || "");
  const type = index === 0 ? "gold" : "silver";
  const typehigh = index === 0 ? "GOLD" : "SILVER";
  const [menu, setMenu] = useState(location?.state?.menu || "order");
  const [trade, settrade] = useState([
    {
      orderPrice: 0,
      remainGram: 0,
    },
  ]);
  const [feeRate, setFeeRate] = useState([]);

  useEffect(() => {
    initFeeRate();
  }, []);

  const initFeeRate = async () => {
    // 수수료율 조회

    const feeRate = [
      { configType: "BUY_FEE_RATE", assetType: "GOLD", value: 0.02 },
      { configType: "SELL_FEE_RATE", assetType: "GOLD", value: 0.015 },
      { configType: "BUY_FEE_RATE", assetType: "SILVER", value: 0.025 },
      { configType: "SELL_FEE_RATE", assetType: "SILVER", value: 0.025 },
    ];

    const assetTypes = ["GOLD", "SILVER"];
    const configTypes = ["BUY_FEE_RATE", "SELL_FEE_RATE"];

    for (let configType of configTypes) {
      for (let assetType of assetTypes) {
        await APIS.getSharedCodeTrade(configType, assetType).then(
          ({ data: { success, data } }) => {
            if (success) {
              feeRate.find(
                ({
                  configType: defaultConfigType,
                  assetType: defaultAssetType,
                }) =>
                  defaultConfigType === configType &&
                  defaultAssetType === assetType
              )["value"] = data.value;
            }
          }
        );
      }
    }

    setFeeRate(feeRate);
  };

  useEffect(() => {
    setMenu("order");
  }, [index]);

  function setIndexFunc(price, method) {
    setPrice(price);
    //setmethod(method);
  }

  const currentchFunc = (dataH) => {
    settrade(dataH);
  };

  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);
  useEffect(() => {
    setContentHeight(contentRef.current.offsetHeight);
  }, []);

  // 로그아웃 상태 -> 로그인 필요 팝업
  // SNS 로그인 상태 -> 본인인증 페이지 이동
  const authBlock = () => {
    if (auth?.role?.LEVEL < ROLE.ROLE_TEMP.LEVEL) {
      // 로그아웃 상태
      dispatch(
        actionShow(
          "로그인 후 이용 가능합니다",
          ["닫기", "로그인"],
          [null, () => history.push(routes.signIn)]
        )
      );
      return false;
    } else if (auth?.role?.LEVEL < ROLE.ROLE_SELF_VERIFICATION.LEVEL) {
      // SNS 로그인 상태
      history.push(routes.selfVerification, { purpose: "SIGNUP" });
      return false;
    }
    return true;
  };

  return (
    <MainLayout
      white
      topbar={<Tabs index={index} onIndexChange={setIndex} />}
      bottomSize="160"
    >
      <Header settype={typehigh} trade={trade} />
      <Flex row>
        <ButtonBase
          onClick={() => {
            setMenu("order");
          }}
          className={
            classes.value + " " + (menu === "order" && classes.valueSel)
          }
        >
          주문
        </ButtonBase>
        <ButtonBase
          onClick={() => {
            if (authBlock()) {
              setMenu("history");
            }
          }}
          className={
            classes.value + " " + (menu === "history" && classes.valueSel)
          }
        >
          진행중
        </ButtonBase>
      </Flex>
      <Flex
        key={index.toString()}
        row
        className={classes.content}
        innerRef={contentRef}
      >
        {menu === "order" ? (
          <>
            <Flex style={{ flex: 2, height: contentHeight }}>
              <Flex
                style={{
                  height: 30,
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: "#eeeeee",
                  color: "#999999",
                  borderBottom: "1px solid white",
                }}
              >
                <Flex
                  style={{
                    flex: 3,
                    textAlign: "center",
                    fontSize: 12,
                    // borderRight: "1px solid white",
                  }}
                >
                  가격(원)
                </Flex>
                <Flex style={{ flex: 2, textAlign: "center", fontSize: 12 }}>
                  중량(g)
                </Flex>
              </Flex>
              {!!contentHeight && (
                <List
                  settype={typehigh}
                  onpriceChange={setIndexFunc}
                  currentchFunc={currentchFunc}
                  height={contentHeight - 30}
                />
              )}
            </Flex>
            <Form
              settype={typehigh}
              onChangePrice={setIndexFunc}
              price={price}
              method={method}
              feeRates={feeRate}
              authBlock={authBlock}
            />
          </>
        ) : (
          <History settype={typehigh} type={type} />
        )}
      </Flex>
    </MainLayout>
  );
}

const useStyle = makeStyles({
  button: { flex: 1 },
  value: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    flex: 1,
    color: "#999999",
    fontSize: "14px",
    backgroundColor: "#eeeeee",
    padding: "10px",
    fontFamily: fonts.notoSansKRMedium,
  },
  valueSel: {
    backgroundColor: colors.primary,
    color: colors.white,
  },
  content: {
    alignItems: "stretch",
    flex: 1,
  },
});
